<ng-content />
<div class="caption">
  <kb-line-clamp lines="2">
    <ng-content select="figcaption" />
  </kb-line-clamp>
</div>
